import * as Core from '../core';

export interface ProvaPracticeStatus {
    available: boolean;
    canStart: boolean;
    message: string;
    titleKeys: string[];
}

export class ProvaService {
    public static async getStatus(): Promise<ProvaPracticeStatus> {
        const route = Core.API.ServerRoute.forAction('prova', 'status');
        return await Core.API.get(route);
    }

    public static async startAttempt(titleKey: string): Promise<Core.Models.ProvaAttempt> {
        const route = Core.API.ServerRoute.forAction('prova', 'attempts');
        return await Core.API.post(route, { titleKey });
    }

    public static async listMyAttempts(): Promise<Core.Models.ProvaAttempt[]> {
        const route = Core.API.ServerRoute.forAction('prova', 'attempts/me');
        return await Core.API.get(route);
    }

    public static async listAttemptsForUser(userId: string): Promise<Core.Models.ProvaAttempt[]> {
        const route = Core.API.ServerRoute.forAction('users', `${userId}/prova-attempts`);
        return await Core.API.get(route);
    }

    public static async cancelAttempt(attemptId: string): Promise<void> {
        const route = Core.API.ServerRoute.forAction('prova', `attempts/${attemptId}`);
        await Core.API.delete(route);
    }
}
